 
<template>
<Tooltip transfer :content="validMsg" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
  <div
    :class="getEditClass"
    v-click-outside.capture="onClickOutside"
    v-click-outside:mousedown.capture="onClickOutside"
    @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut"
  >
    
    <div :class="[prefixCls + '-rel']">
      <template>
        <Tooltip transfer :content="myContent" :disabled="!(!(validErr&&validErrMsgTip)&&showTooltip)" class="ivu-table-cell-tooltip" >
          <p ref="content" @mouseenter="handleTooltipIn" 
            @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content" >{{ myContent }}</p>
        </Tooltip>
      </template>
    </div>
    <template>
      <div :class="[prefixCls + '-popper']" v-if="visible">
        <div :class="[prefixCls + '-content']">
          <Input
            ref="input"
            @on-change="change"
            v-model="myContent"
            v-on:keyup.enter.native="onEnter"
            :placeholder="editCfg.placeholder"
            :disabled="getDisabled()"
            @on-blur="blur"
            :search="editCfg.search"
            @on-search="onSearch"
          />
        </div>
      </div>
    </template>
  </div>
</Tooltip>
</template>
<script>
const prefixCls = "table-edit";
import { directive as clickOutside } from "@/utils/component/v-click-outside-x";
import Tooltip from "../../tooltip/tooltip.vue";
export default {
  name: "plugInput",
  components: { Tooltip },
  directives: { clickOutside },
  props: {
    content: {
      type: [String, Number],
      default: ""
    },
    col: [String, Number, Object],
    row: [String, Number, Object],
    editCfg: Object,
    visible: {
      type: Boolean,
      default: false
    },
    //配置table是否一直显示编辑器
    editAlways: {
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    validErr:{
      type: Boolean,
      default: false
    },
    validMsg:String,
    maxWidth: {
      type: [String, Number]
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      myContent: "",
      myDisabled:false,
      showTooltip: false,
      focus: false,
      validErrMsgTip:false
    };
  },
  computed: {
    getEditClass() {
      return [
        `${this.prefixCls}`,
        {
          [`${this.prefixCls}-always`]:
            (this.editAlways || this.always) && !this.visible,
          [`${this.prefixCls}-disabled`]:this.getDisabled(),
          [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
        }
      ];
    }
  },
  watch: {
    visible(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(function() {
          this.$refs.input.focus();
          this.focus = true;
        });
      }
    },
    content() {
      this.setMyContent();
    }
  },
  methods: {
    setMyContent() {
      this.myContent = this.content;
    },
    onClickOutside() {
      if (this.focus) {
        let value = this.myContent;
        this.focus = false;
        this.$emit("onChangeShowEdit", false,value);
      }
    },
    blur() {
      // this.$emit('onChangeShowEdit',false)
    },
    change(event) {
      let value = this.myContent;
      if (this.number && value !== "")
        value = Number.isNaN(Number(value)) ? value : Number(value);
      this.$emit("onChange", value, this.col);
    },
    handleTooltipIn() {
      const $content = this.$refs.content;
      this.showTooltip = $content.scrollWidth > $content.offsetWidth;
    },
    handleTooltipOut() {
      this.showTooltip = false;
    },
    validErrMsgTipIn(){
      this.validErrMsgTip=true
    },
    validErrMsgTipOut(){
      this.validErrMsgTip=false
    },
    onEnter(event) {
      if (this.editCfg.onEnter) {
        let value = this.myContent;
        this.editCfg.onEnter(this, value, this.col, this.row, this.editCfg);
      }
    },
    getDisabled(item) {
       let myDisabled=this.editCfg.setDisabled
        ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
        : this.editCfg.disabled;
        if(myDisabled){
            this.$emit("setColEditDisabled", myDisabled);
        }
        return myDisabled
    },
    onSearch() {
      if (this.editCfg.onSearch) {
        let value = this.myContent;
        this.editCfg.onSearch(this, value, this.col, this.row, this.editCfg);
      }
    }
  },
  mounted() {
    this.setMyContent();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/table/plug/input.vue